export default __webpack_public_path__ + "static/media/service-3.7f4b9547.svg";